import { Box, Button, IconButton, Paper, Stack, TextField, Typography } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import AddIcon from "@mui/icons-material/Add";

interface Props {
    block: AccordionBlock;
    onChange: (content: any) => void;
    onDelete: () => void;
}

const AccordionBlockEditor = ({ block, onChange, onDelete }: Props) => {
    const items = block.content.items || [];

    const addItem = () => {
        onChange({
            items: [...items, { title: "New Item", content: "" }],
        });
    };

    const updateItem = (index: number, field: "title" | "content", value: string) => {
        const newItems = [...items];
        newItems[index] = { ...newItems[index], [field]: value };
        onChange({ items: newItems });
    };

    const deleteItem = (index: number) => {
        const newItems = items.filter((_, i) => i !== index);
        onChange({ items: newItems });
    };

    return (
        <Paper sx={{ p: 2, mb: 2 }}>
            <Stack direction="row" spacing={1} alignItems="flex-start">
                <IconButton size="small" sx={{ cursor: "grab" }}>
                    <DragIndicatorIcon />
                </IconButton>
                <Box flex={1}>
                    <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: "bold" }}>
                        Accordion Block
                    </Typography>
                    <Stack spacing={2}>
                        {items.map((item, index) => (
                            <Paper key={index} sx={{ p: 2, bgcolor: "#f5f5f5" }}>
                                <Stack spacing={1}>
                                    <Stack direction="row" spacing={1} alignItems="center">
                                        <TextField
                                            label={`Item ${index + 1} Title`}
                                            value={item.title}
                                            onChange={(e) => updateItem(index, "title", e.target.value)}
                                            fullWidth
                                            size="small"
                                        />
                                        <IconButton
                                            size="small"
                                            onClick={() => deleteItem(index)}
                                            color="error"
                                        >
                                            <DeleteIcon />
                                        </IconButton>
                                    </Stack>
                                    <TextField
                                        label={`Item ${index + 1} Content`}
                                        value={item.content}
                                        onChange={(e) => updateItem(index, "content", e.target.value)}
                                        fullWidth
                                        size="small"
                                        multiline
                                        rows={2}
                                    />
                                </Stack>
                            </Paper>
                        ))}
                        <Button
                            startIcon={<AddIcon />}
                            onClick={addItem}
                            variant="outlined"
                            size="small"
                        >
                            Add Accordion Item
                        </Button>
                    </Stack>
                </Box>
                <IconButton size="small" onClick={onDelete} color="error">
                    <DeleteIcon />
                </IconButton>
            </Stack>
        </Paper>
    );
};

export default AccordionBlockEditor;
